import type { TranslationInterface } from './translation.types';

export const deLocale: TranslationInterface = {
  'write-a-message': 'Nachricht schreiben...',
  'session-closed-lead': 'Ihr Problem wurde gelöst!',
  'new-conversation': 'Neue Konversation',
  'welcome-title': 'Willkommen in unserem Support-Chat',
  'welcome-description':
    'Wir sind hier, um zu helfen! Beginnen Sie ein Gesprách und wir werden so schnell wie mogelijk antworten.',
  'your-name': 'Ihr Name',
  'your-email': 'Ihre E-Mail-Adresse',
  'start-chat': 'Mit dem Support sprechen',
  'starting-chat': 'Verbindung wird hergestellt...',
  'i-need-more-help': 'Ich brauche weitere Hilfe',
  'this-was-helpful': 'Dies war hilfreich',
  optional: 'Optional',
  'no-conversations-yet': 'noch keine Gespräche',
  'back-to-conversations': 'Zurück zur Konversationen',
  'closed-conversations': 'Geschlossene Konversationen',
};
